
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
// Import CSS files directly without module resolution
import './index.css'
import './App.css'
import './i18n' 

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
